<template>
  <navbar>
    <template v-slot:navbarTitle>モニターシステム</template>
  </navbar>

  <main id="main" class="container-fluid pt-3">
    <div class="d-flex gap-2 mb-3">
      <h5 class="m-0 p-0">
        <i class="bi bi-clipboard me-1"></i>{{ inspection_type.name }}
      </h5>
      <div class="ms-auto">
        <button
          type="button"
          @click="showInspectionForm"
          class="btn btn-primary me-1"
        >
          <span class="d-block d-sm-none"><i class="bi bi-plus-lg"></i></span>
          <span class="d-none d-sm-block"
            ><i class="bi bi-plus-lg me-1"></i>検査資料を追加する</span
          >
        </button>
        <button class="btn btn-danger" v-on:click.prevent="removeData()">
          <span class="d-block d-sm-none"><i class="bi bi-trash"></i></span>
          <span class="d-none d-sm-block">削除</span>
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-start gap-2 mb-2">
      <div class="me-auto col-6 col-lg-4 col-xl-3">
        <search-form
          :query="query"
          query-key="name"
          placeholder="検査資料名で検索"
          :use-search-modal="false"
          @update-search-query="onUpdateSearchQuery"
        ></search-form>
      </div>
      <pagination :prev="prev" :next="next" @move-page="movePage"></pagination>
    </div>

    <!-- inspections -->
    <div v-if="inspections && inspections.length > 0">
      <div class="table-responsive">
        <table class="table table-bordered bg-white">
          <thead>
            <tr>
              <th scope="col" class="col-sm-9">検査資料名</th>
              <th scope="col" class="col-sm-1">有効</th>
              <th scope="col" class="col-sm-2">更新日時</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="inspection in inspections" :key="inspection.id">
              <td scope="row">
                <router-link
                  :to="{
                    name: 'ManageInspectionMonitorDetail',
                    params: { id: inspection.id },
                  }"
                  >{{ inspection.name }}</router-link
                >
              </td>
              <td class="text-center">
                <ActiveStatus :is_active="inspection.is_active" />
              </td>
              <td class="text-end">{{ inspection.updated_at }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <p v-else class="mt-3">該当するデータはありません。</p>
  </main>

  <InspectionForm ref="inspectionForm" @insert-inspection="insertInspection" />
  <Confirm ref="confirmDataDelete" @confirm-true="confirmDataDelete" />
</template>

<script>
import inspectionStore from '@/apps/inspection/manage/store'
import Pagination from '@/components/AppNoCountPagination.vue'
import Navbar from '@/components/Navbar.vue'
import ActiveStatus from '@/components/TheActiveStatus.vue'
import Confirm from '@/components/TheConfirm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import InspectionForm from '../components/InspectionForm.vue'
import store from '../store'

export default {
  name: 'ManageInspection',
  components: {
    Navbar,
    Pagination,
    ActiveStatus,
    SearchForm,
    InspectionForm,
    Confirm,
  },

  data() {
    return {
      query: {},
    }
  },

  computed: {
    inspection_type() {
      return store.getters['inspection/inspection_type']
    },
    inspections() {
      return store.getters['inspection/inspections']
    },
    prev() {
      return store.getters['inspection/prev']
    },
    next() {
      return store.getters['inspection/next']
    },
    saveQuery() {
      return store.getters['inspection/query']
    },
    searchItems() {
      return [
        {
          id: 'name',
          label: '資料名（前方一致）',
          type: 'text',
        },
        {
          id: 'is_active',
          label: '有効',
          type: 'checkbox',
        },
      ]
    },
  },

  async created() {
    if (!this.inspection_type || !this.inspection_type.id) {
      this.$store.dispatch('alert/setErrorMessage', {
        message: '不正なアクセスです。',
      })
      window.setTimeout(() => {
        this.$router.push({
          name: 'AppHomeManage',
        })
      }, this.$store.getters['alert/timeout'])
    } else {
      this.query = this.saveQuery
      await this.getQueryData()
    }
  },
  beforeRouteLeave(to, from, next) {
    // 詳細画面または作成画面以外のページに移動する場合にデータをクリアする
    if (
      to.name !== 'ManageInspectionMonitorDetail' &&
      to.name !== 'ManageInspectionMonitorCreate'
    ) {
      store.dispatch('inspection/clearAll')
    }
    next()
  },

  methods: {
    getData() {
      return store.dispatch('inspection/fetchAll')
    },
    async getQueryData() {
      store.commit('inspection/setQuery', this.query)
      await this.getData()
    },
    async movePage(page) {
      this.query = Object.assign(this.query, { page: page })
      await this.getQueryData()
    },
    async onUpdateSearchQuery(query = {}) {
      this.query = query
      await this.getQueryData()
    },
    showInspectionForm() {
      this.$refs.inspectionForm.show()
    },
    insertInspection(inspection) {
      // ページ移動
      this.$router.push({
        name: 'ManageInspectionMonitorDetail',
        params: { id: inspection.id },
      })
    },
    removeData() {
      if (this.inspections && this.inspections.length > 0) {
        this.$store.dispatch('alert/setErrorMessage', {
          message: '使用しているため削除できません。',
        })
      } else {
        this.$refs.confirmDataDelete.showConfirm(
          'データを削除',
          '検査資料を削除しますか？\nすでに使用している場合は削除できません。',
        )
      }
    },
    async confirmDataDelete() {
      try {
        await inspectionStore.dispatch(
          'inspection_type/deleteData',
          this.inspection_type.id,
        )
        this.$router.push({
          name: 'AppHomeManage',
        })
      } catch (error) {
        this.$store.dispatch('alert/setErrorMessage', {
          message: 'データの削除に失敗しました。',
        })
      }
    },
  },
}
</script>
